import { proxyTrpc } from '../trpc/proxy.client'

type SyncParams = Parameters<typeof proxyTrpc.sync.mutate>[0]

export class SyncService {
  events: SyncParams[]

  constructor() {
    this.events = []
    setInterval(() => void this.flush(), 2000)
  }

  private async flush() {
    while (this.events.length > 0) {
      const event = this.events.shift()
      if (!event) {
        continue
      }

      if (event.model === 'node') {
        await proxyTrpc.sync.mutate(event, {
          context: {
            // we don't want to batch node updates
            skipBatch: true,
          },
        })
      } else {
        // allow batching of other updates
        void proxyTrpc.sync.mutate(event)
      }
    }
  }
}
